import { ExternalMedia } from './external-media';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class EditCustomerCommand {
  CustomerId: string;
  CustomerName: string;
  CustomerReference: string;
  CustomerStatusId: string;
  CustomerImage: ExternalMedia;
  ApprovalExpires: string;
  Latitude: number;
  Longitude: number;
  CustomerAddress: string;
  EmailAddress: string;
  PhoneNumber: string;
  Website: string;
}


